import { render, staticRenderFns } from "./DebtorListItem.vue?vue&type=template&id=6561413f&scoped=true"
import script from "./DebtorListItem.vue?vue&type=script&lang=js"
export * from "./DebtorListItem.vue?vue&type=script&lang=js"
import style0 from "./DebtorListItem.vue?vue&type=style&index=0&id=6561413f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561413f",
  null
  
)

export default component.exports